import React from 'react';
import styled from 'styled-components';
import { Wrapper } from 'AppReact';
import device from 'components/atoms/utils/device';



const template = styled.div`
    margin: 35px 0;
   
    @media ${device.tablet} {
            margin: 80px 0;
        }
`

export default Wrapper(template);
